<div class="education">
  <h2 class="mat-display-2">Beratung</h2>
  <div class="content-page">
    <div>
      <h1>
        <strong>Beratung für institutionelle Kunden</strong>
      </h1>
      <p>
        Aus unserer langjährigen Erfahrung in der Bildungs-, Projekt- und politischen Arbeit haben wir ein
        Beratungsangebot entwickelt:
      </p>
    </div>
    <div>
      <ul>
        <li>Wir teilen unsere Erfahrungen und unser Wissen mit Ihnen.</li>
        <li>Wir vermitteln Expert*innen zu den Themen: Erwachsenenbildung, Diversity, Kultur, Politik und
          Digitalisierung
        </li>
        <li>Wir entwickeln gemeinsam mit Ihnen Strategien und Konzepte für Ihren Arbeitskontext.</li>
      </ul>

      <div>
        <p>Kontaktieren Sie uns für ein kostenfreies Erstgespräch: </p>
        <strong>Telefon:</strong> 0231 28678 165
      </div>

      <app-contact-vermittlung formName="Beratung inst. Kunden"></app-contact-vermittlung>
    </div>
<!--    <div>-->
<!--      <h1>-->
<!--        <strong>Bildungsberatung für individuelle Kunden </strong>-->
<!--      </h1>-->
<!--      <p>-->
<!--        Wir beraten Sie bei der Entwicklung ihrer beruflichen Bildungsbiografie und bei der Anerkennung Ihrer-->
<!--        ausländischen Bildungsabschlüsse. <br><br>-->

<!--        Kontaktieren Sie uns und vereinbaren Sie ein Erstgespräch!-->
<!--      </p>-->
<!--      <app-contact-vermittlung formName="Bildungsberatung"></app-contact-vermittlung>-->
<!--    </div>-->
  </div>
</div>
